import { PCC_AVAILABLE_TOOLTIP_DISCLAIMER_TYPE } from 'constants/messageCode';
import { PCC_AVAIL_REMOVE_INTERIM_STOCK_FLAG } from 'constants/featureFlag';
import ModernAvailability from 'components/availability-wrapper/modern-availability/modern-availability';
import LegacyAvailability from 'components/availability-wrapper/legacy-availability/legacy-availability';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';

const PartsAvailabilityWrapper = ({
  availabilityData,
  shouldDisplayLabel,
  isLoading,
  partsDiagramMobileView = false,
  openInDrawer = false,
  showAvailabilityAsBottomDrawer = false,
  isPccPdpHeaderUpdateMobile = false
}) => {
  const { hoseAvailabilityLabel, hoseAssemblyIndicator } = availabilityData;
  const hoseAssemblyDetails = { hoseAvailabilityLabel, hoseAssemblyIndicator };

  const { serverData } = usePartDiagram();
  const locale = serverData?.locale;
  const dealerData = serverData?.dealerData;
  const address = serverData?.dealerData?.address;
  const isShowSourcingDetailEnabled = serverData?.isShowSourcingDetailEnabled;
  const isDeliveryEnabled = serverData?.isDeliveryEnabled;
  const availRemoveInterimStockFlag =
    serverData?.storefeatures?.[PCC_AVAIL_REMOVE_INTERIM_STOCK_FLAG];

  const availabilityToolTipMessage = PCC_AVAILABLE_TOOLTIP_DISCLAIMER_TYPE;

  const {
    storeFeatures: { isStoreAvailabilityEnabled, isPickupEnabled },
    featureFlags: { PCC_availRemoveInterimStockFlag }
  } = serverData?.dealerInformation ?? {
    storeFeatures: {},
    featureFlags: {}
  };

  return isStoreAvailabilityEnabled ? (
    <ModernAvailability
      availabilityData={availabilityData?.availability}
      availabilityToolTipMessage={availabilityToolTipMessage}
      isPickupEnabled={isPickupEnabled}
      isDeliveryEnabled={isDeliveryEnabled}
      showSourcingDetailToggle={isShowSourcingDetailEnabled}
      hideLabel={!shouldDisplayLabel}
      sourcingDetails={availabilityData?.sourcingDetails}
      hoseAssemblyDetails={hoseAssemblyDetails}
      address={address}
      locale={locale}
      isLoading={isLoading}
      availRemoveInterimStockFlag={availRemoveInterimStockFlag}
      storeAvailability={availabilityData?.storeAvailability}
      PCC_availRemoveInterimStockFlag={PCC_availRemoveInterimStockFlag}
      hideSourceAndDates={false}
      hideToolTipIcon={false}
      shouldWrap={true}
      openInDrawer={openInDrawer}
      partsDiagramMobileView={partsDiagramMobileView}
      showAvailabilityAsBottomDrawer={showAvailabilityAsBottomDrawer}
      isPCC_PDP_headerUpdateMobileView={isPccPdpHeaderUpdateMobile}
    />
  ) : (
    <LegacyAvailability
      availabilityData={availabilityData?.availability}
      isPickupEnabled={isPickupEnabled}
      isDeliveryEnabled={isDeliveryEnabled}
      dealerData={dealerData}
      hideLabel={true}
      isLoading={isLoading}
      availabilityToolTipMessage={availabilityToolTipMessage}
      hoseAssemblyDetails={hoseAssemblyDetails}
      hideToolTipIcon={false}
    />
  );
};

export default PartsAvailabilityWrapper;
